var BOLD = BOLD || {};
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.KN = BOLD.BMS.KN || {};

BOLD.BMS.KN.Cart = function() {
    "use strict";

    function init() {
        bind();
    }

    function bind() {
    }
    
    function getCart(calback) {
        $.getJSON('/cart.js',
            function(cart){
                callback(cart);
            }
        );
    }

    function setAttribute(attribute, value) {
        var attributes = {};
        attributes[attribute] = value;
        
        $.ajax({
            url:'/cart/update.js',
            data: {
                attributes: attributes
            },
            dataType:'json',
            type:'post'
        })
    }

    return {
        init: init,
        getCart: getCart,
        setAttribute: setAttribute
    }
}(BOLD.jQuery || jQuery);